module.exports = __webpack_public_path__ + "assets/img/fangan01.7bde396e.png";